import React, { HTMLProps } from 'react'
import { Color, Direction } from '../../../utils/constants'
import { FormattedMessage } from 'react-intl'
import Button from '../../../components/Button/Button'

const BackToTop = ({ className }: HTMLProps<HTMLButtonElement>) => {
    return (
        <div className={className}>
            <Button
                type='button'
                buttonColor={Color.PURPLE}
                chevron={Direction.UP}
                onClick={() => window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })}
            >
                <FormattedMessage id='button.backToTop'>
                    {(value) => <span className='footer-link'>{value}</span>}
                </FormattedMessage>
            </Button>
        </div>
    )
}

export default BackToTop
